__webpack_require__.p = "https://u-tec.lv/packs/";